import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { WorkflowTemplateDialogModel } from 'src/app/ViewModel/WorkflowTemplateDialogModel';
import { WFTCartDialogOutputModel, WorkflowTemplateStatusInputModel } from 'src/app/ViewModel/WorkflowTemplateStatusInputModel';
import { groupBy } from 'lodash';
import { WftdBodyInputComponent } from '../wftd-body-input/wftd-body-input.component';
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { Module } from 'src/app/Service/element-details.data.service';
import { IScheduleType } from 'src/app/ViewModel/ScheduleDocumentModel';
import { WorkflowTemplateDataService } from 'src/app/Service/workflow-template/workflow-template-data.service';

@Component({
	selector: 'app-add-workflow-template-dialog',
	templateUrl: './add-workflow-template-dialog.component.html',
	styleUrls: ['./add-workflow-template-dialog.component.css']
})
export class AddWorkflowTemplateDialogComponent implements OnInit {

	@ViewChild(WftdBodyInputComponent) bodyInputComponent!: WftdBodyInputComponent;

	enableFullscreen = false;
	enableFilter = false;
	wfTemplateHasError = false;
	selectedElementClear = 'N';
	elementsList: any[] = [];
	selectedModuleId = '';
	workflowTask: number = 0;
	selectedModuleClear = 'N';
	moduleList: any[] = [];

	/** Kendo list */
	templateList: any[] = [];
	public workflowIntegrateToList: RoleFeatureModel[] = [];
	public statusList: RoleFeatureModel[] = [];
	workFlowTaskList: RoleFeatureModel[] = [];
	selectedWorkFlowTaskDescription: string = '';

	templateArray = [{}];
	workflowTemplateList = [];
	icList: any[] = [];
	buList: any[] = [];
	projectList: ProjectViewModel[] = [];
	businessGroupList: BusinessGroupModel[] = [];
	scheduleTypeList: IScheduleType[] = [{ schType_Id: 1, schType_Name: "DCI" }, { schType_Id: 2, schType_Name: "Ext DCI" }, { schType_Id: 3, schType_Name: "Std DCI" }, { schType_Id: 4, schType_Name: "Vendor DCI" }];
	workFlowTemplate: any;
	statuInput!: WorkflowTemplateStatusInputModel;
	clearIcSelected = 'N';
	clearBuSelected = 'N';
	clearProjectSelected = 'N';
	clearBusinessGrpSelected = 'N';
	clearWfStatusSelected = 'N';

	icid: number | null = null;
	icDescription: string = '';

	buid: number | null = null;
	buDescription: string = '';

	projectId: number | null = null;
	projectDescription: string = '';

	businessGroupId: number | null = null;
	businessGroupDescription: string = '';

	scheduleTypeid: number | null = null;
	scheduleTypeDescription: string = '';
	templateName = '';
	templateDescription = '';
	isForsupersede = true;
	isForReAssignment = true;
	bottomKendoList = [];
	workFlowStatusList = [];
	workflowId: number | null = null;
	selectedTaskId!: number;
	selectedTaskStageId!: number;
	icIsDisabled: boolean = false;
	projectIsDisabled: boolean = false;
	clearValue: string = "N"
	workFlowTemplateApiResponse!: WorkflowTemplateDialogModel | any;

	constructor(@Inject(MAT_DIALOG_DATA) public data: any,
		public commonService: CommonService,
		public notificationService: NotificationService,
		public dialogRef: MatDialogRef<AddWorkflowTemplateDialogComponent>,
		public workflowTemplateService: WorkflowTemplateService,
		public mapRoleFeatureService: MapRoleFeatureService,
		public projectInfoService: ProjectInfoService,
		public WorkflowTemplateDataService: WorkflowTemplateDataService
	) { }

	ngOnInit() {
		this.projectId = (!!this.data && !!this.data['SrcProject']) ? this.data['SrcProject'] : null;
		this.businessGroupId = (!!this.data && !!this.data['SrcBG']) ? this.data['SrcBG'] : null;
		this.projectList = (!!this.data && !!this.data['projectList']) ? this.data['projectList'] : null;
		this.icList = (!!this.data && !!this.data['icList']) ? this.data['icList'] : null;
		this.buList = (!!this.data && !!this.data['buList']) ? this.data['buList'] : null;
		this.businessGroupList = (!!this.data && !!this.data['businessGroupList']) ? this.data['businessGroupList'] : null;

		this.getWorkflowIntegrateTo();
		this.getWorkflowStatus();

		this.workflowTemplateList = this.data['workflowTemplateList'];

		this.workflowTemplateService.isCreateMode = this.data.isCreateMode;
		this.workflowTemplateService.isEditMode = this.data.isEditMode;
		this.workflowTemplateService.isViewMode = this.data.isViewMode;


		if (!!this.data['dataItem'] && this.data['dataItem']['workflowId']) {
			this.workflowId = this.data['dataItem']['workflowId'];
			this.getBottomKendoData(this.data['dataItem']['workflowId']);
		} else {
			this.workflowId = null;
			this.workflowTemplateService.supportForBottomKendo.next([]);
			this.bodyInputComponent.parentTaskId = 1;
		}
		this.bodyInputComponent.parentWorkflowId = this.workflowId;

		this.workflowTemplateService.supportForClearMainData.subscribe((data: any) => {
			if (data) {
				this.clearThisComponentInput();
			}
		});
		this.workflowTemplateService.supportForClearSelectedWfStatus.subscribe((data: any) => {
			if (data) {
				this.clearWfStatusSelectedFun();
			}
		})
		this.workflowTemplateService.customTaskId = 1;
	}

	GetTemplateDetails(): any {
		return {
			SrcProject: this.data['SrcProject'],
			SrcBG: this.data['SrcBG'],
			DestProject: this.projectId,
			DestBG: this.businessGroupId
		}
	}

	public getWorkflowStatus() {
		this.workflowTemplateService.getWorkflowTaskList(this.businessGroupId, Module.Workflow, "Workflow", null, "Workflow Status", null, null, this.projectId).subscribe((data: any) => {
			this.statusList = data;
		});
	}

	public getWorkflowIntegrateTo() {
		this.workflowTemplateService.getCommonDEDAgainstDE("Workflow IntegrateTo").subscribe((data: any) => {
			this.workflowIntegrateToList = data;
		});
	}

	public getWorkflowStatusName(id: number) {
		if (this.statusList.filter(item => item.dedId == id).length > 0)
			return this.statusList.filter(item => item.dedId == id)[0]["dedDescription"];
		else
			return '';
	}

	public getWorkflowIntegrateToName(id: number) {
		if (this.workflowIntegrateToList.filter(item => item.dedId == id).length > 0)
			return this.workflowIntegrateToList.filter(item => item.dedId == id)[0]["dedDescription"];
		else
			return '';
	}

	closeDialog() {
		this.dialogRef.close();
	}

	async getBusinessGroup(projectId: number | null) {
		if (!projectId) {
			this.businessGroupList = [];
			return;
		}

		this.mapRoleFeatureService.getBusinessGroups(projectId).subscribe((data: BusinessGroupModel[]) => {
			this.businessGroupList = data.filter(each => each.is_Active);
		});
	}

	async getProject() {
		this.projectInfoService.getProjectList(this.commonService.getLoggedInUserId()).subscribe((data: ProjectViewModel[]) => {
			if (data) {
				data.forEach(x => { x.projectDescription = x.projectCode + ' - ' + x.projectDescription });
			}
			this.projectList = data;
		});
	}

	async getBuList() {
		if (!this.icid) {
			this.buList = [];
			return;
		}

		this.buList = await this.mapRoleFeatureService.getCommonDedAgainstDe(null, "BU").toPromise();
	}

	async getIcList() {
		this.icList = await this.mapRoleFeatureService.getCommonDedAgainstDe(null, "IC").toPromise();
	}

	changeWorkflowTemplateList(event: { value: number; }) {
		if (event.value != -2) {
			this.workflowTemplateService.isCopyMode = true;
			this.getBottomKendoData(event.value, true);
		} else {
			this.workflowTemplateService.isCopyMode = false;

			this.workflowId = null;
			this.workflowTemplateService.supportForBottomKendo.next([]);
			this.bodyInputComponent.parentTaskId = 1;
			this.bodyInputComponent.parentWorkflowId = this.workflowId;

			this.workflowTemplateService.supportForClearMainData.subscribe((data: any) => {
				if (data) {
					this.clearThisComponentInput();
				}
			});
			this.workflowTemplateService.supportForClearSelectedWfStatus.subscribe((data: any) => {
				if (data) {
					this.clearWfStatusSelectedFun();
				}
			})
			this.workflowTemplateService.customTaskId = 1;
			this.workflowTemplateService.supportForClearInputData.next(true);
			this.icid = null;
			this.icDescription = '';
			this.buid = null;
			this.buDescription = '';
			this.projectId = null;
			this.projectDescription = '';
			this.businessGroupId = null;
			this.businessGroupDescription = '';
			this.scheduleTypeid = null;
			this.scheduleTypeDescription = '';
			this.templateName = '';
			this.templateDescription = '';
			this.isForsupersede = true;
			this.isForReAssignment = true;
			this.workFlowStatusList = [];
		}
	}

	changeIc(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
		this.clearIcSelected = 'N';
		this.getBuList();
		if (event.value != '-2') {
			this.icIsDisabled = false;
			this.projectIsDisabled = true;
			this.icid = Number(event.value);
			this.icDescription = event.desc;
		} else {
			this.icIsDisabled = false;
			this.projectIsDisabled = false;
			this.icid = null;
			this.icDescription = '';
			this.clearBuSelected = 'Y';
		}
	}

	changeBu(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
		this.clearBuSelected = 'N';

		if (event.value != '-2') {
			this.buid = Number(event.value);
			this.buDescription = event.desc;
		} else {
			this.buid = null;
			this.buDescription = '';
		}
	}

	changeProject(event: EIPAutoCompleteEventModel<ProjectViewModel>) {
		this.clearProjectSelected = 'N';

		if (event.value != '-2') {
			this.icIsDisabled = true;
			this.projectIsDisabled = false;
			this.projectId = Number(event.value);
			this.projectDescription = event.desc;
		} else {
			this.icIsDisabled = false;
			this.projectIsDisabled = false;
			this.projectId = null;
			this.projectDescription = '';
			this.clearBusinessGrpSelected = 'Y';
		}

		this.clearBusinessGrpSelected = 'Y';
		this.businessGroupId = null;
		this.getBusinessGroup(this.projectId);
	}

	changeBusinessGroup(event: EIPAutoCompleteEventModel<BusinessGroupModel>) {
		this.clearBusinessGrpSelected = 'N';

		if (event.value != '-2') {
			this.businessGroupId = Number(event.value);
			this.businessGroupDescription = event.desc;
		} else {
			this.businessGroupId = null;
			this.businessGroupDescription = '';
		}
	}

	changeScheduleType(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
		if (event.value != '-2') {
			this.scheduleTypeid = Number(event.value);
			this.scheduleTypeDescription = event.desc;
		} else {
			this.scheduleTypeid = null;
			this.scheduleTypeDescription = '';
		}
	}

	array_unique(arr: string | any[]) {
		var result = [];
		for (var i = 0; i < arr.length; i++) {
			if (result.indexOf(arr[i]) == -1) {
				result.push(arr[i]);
			}
		}
		return result;
	}

	/**
	 * combine values of mat expansion input, To cart, Cc cart, Action cart
	 * @param event
	 */
	getInputValues(event: { inputFormGroupValue: any; actionCart: any; toCart: any[]; ccCart: any[]; }) {
		this.wfTemplateHasError = false;

		if (!this.templateName.trim()) {
			this.notificationService.showToast("Enter Template name", "Warning");
			return;
		}

		if (!this.templateDescription.trim()) {
			this.notificationService.showToast("Enter Template description", "Warning");
			return;
		}

		if (!this.icid && !this.buid && !this.projectId && !this.businessGroupId) {
			this.notificationService.showToast('Select anything from IC, BU, Project and Business Group list', 'Warning');
			return;
		}

		if (!this.scheduleTypeid) {
			this.notificationService.showToast("Select Schedule Type", "Warning");
			return;
		}

		let reqData: any = {
			"project_Id": this.projectId,
			"project_Description": this.projectDescription,

			"ic_Id": this.icid,
			"ic_Description": this.icDescription,
			"bu_Id": this.buid,
			"bu_Description": this.buDescription,
			"group_Id": this.businessGroupId,
			"group_Description": this.businessGroupDescription,

			"workflow_Id": null,// creation null
			"workflow_Name": this.templateName,
			"workflow_Description": this.templateDescription,
			"isForsupersede": this.isForsupersede,
			"isForReAssignment": this.isForReAssignment,

			"schedule_Type": this.scheduleTypeid,

			// child component data
			"workflowStatus": [event.inputFormGroupValue],
			"workflowAction": event.actionCart,
			"workflowAssignedTo": [],

			"is_Active": true,
			"created_By": this.commonService.getLoggedInUserId(),
		}

		event.toCart.forEach(each => {
			reqData.workflowAssignedTo.push(each);
		});
		event.ccCart.forEach(each => {
			reqData.workflowAssignedTo.push(each);
		});


		// Check repeated member name and role name in To: and Cc:
		let grpdByMemberId = groupBy(reqData.workflowAssignedTo, 'member_Id');
		delete grpdByMemberId[0];

		let grpdByRoleId = groupBy(reqData.workflowAssignedTo, 'role_Id');
		delete grpdByRoleId[0];

		let repeatedNames: any[] = [];

		Object.keys(grpdByMemberId).forEach(eachKey => {
			if (grpdByMemberId[eachKey] && grpdByMemberId[eachKey].length && grpdByMemberId[eachKey].length > 1) {
				repeatedNames.push(grpdByMemberId[eachKey][0].member_Name);
			}
		});

		Object.keys(grpdByRoleId).forEach(eachKey => {
			if (grpdByRoleId[eachKey] && grpdByRoleId[eachKey].length && grpdByRoleId[eachKey].length > 1) {
				repeatedNames.push(grpdByRoleId[eachKey][0].role_Description);
			}
		});

		if (repeatedNames.length) {
			this.notificationService.showToast(repeatedNames.toString() + ' in both To: & Cc:', 'Warning');
			return;
		}

		/**
		 * WorkflowTemplateDialogModel
		 * here combine all values from all child component
		 */

		reqData.workflowStatus.forEach((each: any) => {
			if (this.workflowTemplateService.isCreateMode) {
				each.workflow_Id = null;
			} else {
				each.workflow_Id = this.workFlowTemplateApiResponse.workflow_Id;
			}

			if (!each.task_Id) {
				each.task_Id = this.bottomKendoList.length + 1;
				each.step_Id = this.bottomKendoList.length + 1;
			}

		});

		reqData.workflowAction.forEach((each: { workflow_Id: number | null; task_Id: number; }) => {
			if (this.workflowTemplateService.isCreateMode) {
				each.workflow_Id = null;
			} else {
				each.workflow_Id = this.workFlowTemplateApiResponse.workflow_Id;
			}

			if (!each.task_Id) {
				each.task_Id = this.bottomKendoList.length + 1;
			}
		});

		reqData.workflowAssignedTo.forEach((each: { workflow_Id: number | null; task_Id: number; }) => {
			if (this.workflowTemplateService.isCreateMode) {
				each.workflow_Id = null;
			} else {
				each.workflow_Id = this.workFlowTemplateApiResponse.workflow_Id;
			}

			if (!each.task_Id) {
				each.task_Id = this.bottomKendoList.length + 1;
			}
		});

		if (this.workflowTemplateService.isCreateMode) {
			reqData.workflow_Id = null
		} else {
			reqData.workflow_Id = this.workFlowTemplateApiResponse.workflow_Id;
		}

		// append bottom kendo data
		if (this.workFlowTemplateApiResponse) {
			let grpdAssignedTo = groupBy(reqData.workflowAssignedTo, 'task_Id');
			let grpdActions = groupBy(reqData.workflowAction, 'task_Id');
			let grpdStatus = groupBy(reqData.workflowStatus, 'task_Id')

			this.workFlowTemplateApiResponse.workflowAssignedTo.forEach((each: { task_Id: string | number; }) => {
				if (!(grpdAssignedTo[each.task_Id] && grpdAssignedTo[each.task_Id].length)) {
					reqData.workflowAssignedTo.push(each);
				}
			});

			this.workFlowTemplateApiResponse.workflowAction.forEach(each => {
				if (!(grpdActions[each.task_Id] && grpdActions[each.task_Id].length)) {
					reqData.workflowAction.push(each);
				}
				if (!(grpdActions[each.task_Id] && grpdActions[each.task_Id].length) && this.workflowTemplateService.isCopyMode) {
					if (this.workFlowTemplateApiResponse.workflowActionCategory.length > 0) {
						this.workFlowTemplateApiResponse.workflowActionCategory.forEach(element => {
							if (each.task_Id == element.task_Id) {

								if (each.action_Id == element.action_Id) {

									each.Document_CategoryList = element.category_Description;

									each.Document_CategoryListId = element.category_Id;
								}

							}
						})
					}
				}
			});
			this.workFlowTemplateApiResponse.workflowStatus.forEach((each: { task_Id: string | number; }) => {
				if (!(grpdStatus[each.task_Id] && grpdStatus[each.task_Id].length)) {
					reqData.workflowStatus.push(each);
				}
			});
		}

		// set workflow id as null in copy mode
		if (this.workflowTemplateService.isCopyMode) {
			if (!reqData.workflowStatus[0]['workflow_Status'])
				reqData.workflowStatus.splice(0, 1);

			reqData.workflow_Id = null;
			reqData.workflowStatus.forEach((each: { workflow_Id: null; }) => {
				each.workflow_Id = null;
			});
			reqData.workflowAssignedTo.forEach((each: { workflow_Id: null; }) => {
				each.workflow_Id = null;
			});
			reqData.workflowAction.forEach((each: { workflow_Id: null; }) => {
				each.workflow_Id = null;
			});
		}

		let uniqueStages = reqData.workflowStatus.map((item: { sub_Workflow: any; }) => item.sub_Workflow).filter((value: any, index: any, self: string | any[]) => self.indexOf(value) === index);

		for (let stage of uniqueStages) {
			let stageWiseSteps = reqData.workflowStatus.filter((item: { sub_Workflow: any; }) => item.sub_Workflow == stage);
			let uniqueStageWiseSteps = stageWiseSteps.map((item: { workflow_Status: any; }) => item.workflow_Status).filter((value: any, index: any, self: string | any[]) => self.indexOf(value) === index);

			if (stageWiseSteps.length != uniqueStageWiseSteps.length) {
				this.wfTemplateHasError = true;
				this.notificationService.showToast("Same stage should not contains duplicate workflow task", "Warning");
				break;
			}
		}

		for (let stage of uniqueStages) {
			let stageWiseSteps = reqData.workflowStatus.filter((item: { sub_Workflow: any; }) => item.sub_Workflow == stage);
			let uniqueStageWiseDueOn = stageWiseSteps.filter((item: { is_Due_On: boolean; }) => item.is_Due_On == true);

			if (uniqueStageWiseDueOn.length > 1) {
				this.wfTemplateHasError = true;
				this.notificationService.showToast("Stage wise 'Is Due On' flag should be enabled for once", "Warning");
				break;
			}
		}

		for (let stage of uniqueStages) {
			let stageWiseSteps = reqData.workflowStatus.filter((item: { sub_Workflow: any; }) => item.sub_Workflow == stage);
			let uniqueStageWiseApprovalStatus = stageWiseSteps.filter((item: { is_Approval_Status: boolean; }) => item.is_Approval_Status == true);

			if (uniqueStageWiseApprovalStatus.length > 1) {
				this.wfTemplateHasError = true;
				this.notificationService.showToast("Stage wise 'Is Approval Status' flag should be enabled for once", "Warning");
				break;
			}
		}

		if (this.wfTemplateHasError) {
			this.wfTemplateHasError = false;
			return;
		}

		if (reqData.workflowAction.length > 0) {
			let workflowActionCategory: any[] = [];
			let workflowAction: any[] = [];
			reqData.workflowAction.forEach((element: { Document_CategoryListId: string; workflow_Id: any; task_Id: any; action_Id: any; action_Description: any; enable_Tag: any; is_Active: any; is_Default: any; next_Step_Id: any; statusDescription: any; status_Id: any; }) => {
				if (!!element.Document_CategoryListId) {
					let obj = {};
					let MapObjCategoryData: any;
					MapObjCategoryData = element.Document_CategoryListId.split(',');
					MapObjCategoryData.forEach((value: string) => {
						obj = {
							"Workflow_Id": element.workflow_Id,
							"Task_Id": element.task_Id,
							"Action_Id": element.action_Id,
							"Is_Active": true,
							"Category_Id": parseInt(value)
						}
						workflowActionCategory.push(obj);
					});
				}

				let obj1 = {
					"action_Description": element.action_Description,
					"action_Id": element.action_Id,
					"enable_Tag": element.enable_Tag,
					"is_Active": element.is_Active,
					"is_Default": element.is_Default,
					"next_Step_Id": element.next_Step_Id,
					"statusDescription": element.statusDescription,
					"status_Id": element.status_Id,
					"task_Id": element.task_Id,
					"workflow_Id": element.workflow_Id
				}
				workflowAction.push(obj1);
			});
			if (workflowActionCategory.length > 0) {
				reqData["workflowActionCategory"] = workflowActionCategory;
			}
			reqData.workflowAction = workflowAction;
		}
		this.workflowTemplateService.postWorkflowTemplate(reqData).subscribe((data: any) => {
			if (data['successCode'] == 200) {
				this.notificationService.handleResponse(data);
				this.getBottomKendoData(data['result']);
				this.workflowTemplateService.isCreateMode = false;
				this.workflowTemplateService.isEditMode = true;
				this.workflowTemplateService.isCopyMode = false;
				this.workflowTemplateService.supportForClearInputData.next(true);
			} else {
				this.notificationService.handleResponse(data);
			}
		});
	}
	getCategory_Description: any[] = []
	/** Set values for bottom kendo data */
	getBottomKendoData(workflowId: number, isFromWfTemplateList?: boolean) {
		this.WorkflowTemplateDataService.deleteWorkflowTemplate(workflowId + 'WorkflowTemplate');
		this.workflowTemplateService.getWorkflowTemplate(workflowId).subscribe((data: WorkflowTemplateDialogModel) => {
			this.workFlowTemplateApiResponse = data;
			this.icid = this.workFlowTemplateApiResponse.ic_Id;
			this.buid = this.workFlowTemplateApiResponse.bu_Id;
			this.projectId = this.workFlowTemplateApiResponse.project_Id;
			this.businessGroupId = this.workFlowTemplateApiResponse.group_Id

			this.templateName = this.workFlowTemplateApiResponse.workflow_Name;
			this.templateDescription = this.workFlowTemplateApiResponse.workflow_Description;
			this.scheduleTypeid = this.workFlowTemplateApiResponse.schedule_Type;
			this.isForsupersede = this.workFlowTemplateApiResponse.isForsupersede;
			this.isForReAssignment = this.workFlowTemplateApiResponse.isForReAssignment;

			if (isFromWfTemplateList) {
				this.workflowId = null;
			} else {
				this.workflowId = workflowId;
			}
			/**
			 * Temp bottom kendo data
			 */
			let bottomKendoData: any = [];
			/**
			 * Get Assigned To,Cc data by task id
			 */
			let grpdAssignedByTaskId = groupBy(data.workflowAssignedTo, 'task_Id');
			/**
			 * Get Workflow action data by task id
			 */
			let grpdWorkflowActionByTaskId = groupBy(data.workflowAction, 'task_Id');

			if (data.workflowActionCategory && data.workflowActionCategory.length > 0) {
				data.workflowActionCategory.forEach((val, index) => {
					let obj: any = {
						"action_Id": Number,
						"is_Active": Boolean,
						"task_Id": Number,
						"workflow_Id": Number,
					};
					if (data.workflowActionCategory && data.workflowActionCategory?.length > 0) {


						let MapCategoryData: any = data.workflowActionCategory.filter(element => val.task_Id == element.task_Id && val.action_Id == element.action_Id)
						if (MapCategoryData.length > 0) {
							obj.action_Id = MapCategoryData[0].action_Id;
							obj.is_Active = MapCategoryData[0].is_Active;
							obj.task_Id = MapCategoryData[0].task_Id;
							obj.workflow_Id = MapCategoryData[0].workflow_Id;
							obj["category_Description"] = MapCategoryData.map((X: { category_Description: any; }) => X.category_Description).toString();
							obj["category_Id"] = MapCategoryData.map((X: { category_Id: any; }) => X.category_Id).toString();
							this.getCategory_Description.push(obj);
						}
					}

				})
			}
			else {
				this.getCategory_Description = [];
			}

			data.workflowActionCategory = this.getCategory_Description;
			data.workflowStatus.forEach(each => {
				let
					toArr: any = [],
					ccArr: any = [],
					actionArr: any = [],
					newData: any = {
						workflow_Status_Description: each.workflow_Status_Description,
						workflow_Status: each.workflow_Status,
						step_Id: each.step_Id,
						task_Order: each.task_Order,
						is_Action_Required: each.is_Action_Required,
						workflowAssignedTo: '',
						workflowAssignedCc: '',
						workflowAction: '',
						task_Id: each.task_Id,
						is_Active: each.is_Active,
						data: each,
						document_CategoryType: this.getCategory_Description.length > 0 ? this.getCategory_Description : null,
						integrationType: this.getWorkflowIntegrateToName(each.integration_Type),
						workflow_Stage: this.getWorkflowStatusName(each.sub_Workflow),
						due_Days: each.due_Days
					};

				if (grpdAssignedByTaskId[each.task_Id] && grpdAssignedByTaskId[each.task_Id].length) {
					grpdAssignedByTaskId[each.task_Id].forEach(eachAssignedTo => {
						if (eachAssignedTo.assign_Type == 1) { // To:
							if (eachAssignedTo.member_Name) {
								toArr.push(eachAssignedTo.member_Name);
							}
							if (eachAssignedTo.role_Description) {
								toArr.push(eachAssignedTo.role_Description);
							}
						} else if (eachAssignedTo.assign_Type == 2) { // Cc:
							if (eachAssignedTo.member_Name) {
								ccArr.push(eachAssignedTo.member_Name);
							}

							if (eachAssignedTo.role_Description) {
								ccArr.push(eachAssignedTo.role_Description);
							}
						}
					});
				}

				if (grpdWorkflowActionByTaskId[each.task_Id] && grpdWorkflowActionByTaskId[each.task_Id].length) {
					grpdWorkflowActionByTaskId[each.task_Id].forEach(eachAction => {
						actionArr.push(eachAction.action_Description);
					});
				}

				newData.workflowAssignedTo = toArr.toString();
				newData.workflowAssignedCc = ccArr.toString();
				newData.workflowAction = actionArr.toString();

				bottomKendoData.push(newData);
			});

			this.workFlowStatusList = this.bottomKendoList = bottomKendoData;

			this.workFlowStatusList.forEach((each: any) => {
				each.WorkflowTaskDisplayText = each.workflow_Stage + ' - ' + each.workflow_Status_Description;
			});

			this.workflowTemplateService.customTaskId = bottomKendoData.length + 1;

			// create mode set child collapse header task id
			if (!this.workflowId) {
				this.bodyInputComponent.parentTaskId = bottomKendoData.length + 1;
			}

			this.workflowTemplateService.supportForBottomKendo.next(bottomKendoData);

			if (isFromWfTemplateList) {
				this.selectedTaskId = this.workFlowTemplateApiResponse.workflowAssignedTo[0].task_Id;
				this.workflowId = null;

				this.workFlowTemplateApiResponse.workflowStatus.forEach(() => {

				});
				this.setDataForSelectedTaskOrder(isFromWfTemplateList);
			}
		});
	}
	/**
	 * Clear this component's input values
	 */
	clearThisComponentInput() {
		this.clearIcSelected = 'Y';
		this.clearBuSelected = 'Y';
		this.clearProjectSelected = 'Y';
		this.clearBusinessGrpSelected = 'Y';
		this.templateName = this.templateDescription = '';
		this.isForsupersede = true;
		this.isForReAssignment = true;

		this.workflowId = null;
		this.workFlowTemplateApiResponse = null;
	}

	changeWorkflowStatus(event?: any) {
		this.clearWfStatusSelected = 'N';
		if (event.value != '-2') {
			if (event.additionalValues) {
				this.selectedTaskId = event.additionalValues.additionalValues.task_Id;
				this.selectedTaskStageId = event.additionalValues.additionalValues.data.sub_Workflow;
			} else {
				this.selectedTaskId = event.task_Id;
				this.selectedTaskStageId = event.data.sub_Workflow;
			}
			this.bodyInputComponent.parentTaskId = this.selectedTaskId;
			this.workflowTemplateService.selectedTaskId = this.selectedTaskId;
			this.workflowTemplateService.isEditMode = true;
			this.setDataForSelectedTaskOrder();

		} else {
			this.workflowTemplateService.selectedTaskId = null;
			this.bodyInputComponent.clearInputValues();
		}

		let rootElement: HTMLElement | null = document.getElementById('carousel-container');
		if (rootElement)
			rootElement.scrollTo({ top: 0, behavior: 'smooth' })
	}

	clearWfStatusSelectedFun() {
		this.clearWfStatusSelected = 'Y';
	}

	/**
	 * Set data to input values in mat expansion component
	 */
	setDataForSelectedTaskOrder(isFromWfTemplateList?: boolean) {
		this.icid = this.workFlowTemplateApiResponse.ic_Id;
		this.buid = this.workFlowTemplateApiResponse.bu_Id;
		this.projectId = this.workFlowTemplateApiResponse.project_Id;
		this.businessGroupId = this.workFlowTemplateApiResponse.group_Id

		this.templateName = this.workFlowTemplateApiResponse.workflow_Name;
		this.templateDescription = this.workFlowTemplateApiResponse.workflow_Description;
		this.isForsupersede = this.workFlowTemplateApiResponse.isForsupersede;
		this.isForReAssignment = this.workFlowTemplateApiResponse.isForReAssignment;

		let grpdWorkflowStatus = groupBy(this.workFlowTemplateApiResponse.workflowStatus, 'task_Id');
		let grpdAssigned = groupBy(this.workFlowTemplateApiResponse.workflowAssignedTo, 'task_Id');
		let grpdActions = groupBy(this.workFlowTemplateApiResponse.workflowAction, 'task_Id');

		let toCartValues: WFTCartDialogOutputModel = {
			'roleSelectedIds': [],
			'roleTextWithValue': [], //{ value: string | number, text: string }
			'roleSelectedNames': [],
			'roleEventsList': [], // need to check

			'memberSelectedIds': [],
			'memberTextWithValue': [], // { value: string | number, text: string }
			'memberSelectedNames': [],
			'memberEventList': [],

			'previousBusinessGroupId': null,

			'totalSelectedNames': [],
		};

		let ccCartValues: WFTCartDialogOutputModel = {
			'roleSelectedIds': [],
			'roleTextWithValue': [], //{ value: string | number, text: string }
			'roleSelectedNames': [],
			'roleEventsList': [], // need to check

			'memberSelectedIds': [],
			'memberTextWithValue': [], // { value: string | number, text: string }
			'memberSelectedNames': [],
			'memberEventList': [],

			'previousBusinessGroupId': null,

			'totalSelectedNames': [],
		};


		grpdAssigned[this.selectedTaskId].forEach(each => {
			if (each.assign_Type == 1) { // To:
				if (each.role_Id) {
					toCartValues.roleSelectedIds.push(each.role_Id);
					toCartValues.totalSelectedNames.push(each.role_Description);
					toCartValues.roleTextWithValue.push(this.workflowTemplateService.getAsCartSelectedValue(each.role_Id, each.role_Description));
					toCartValues.roleEventsList.push({ text: this.workflowTemplateService.getAsCartSelectedValue(each.role_Id, each.role_Description).text });
				}
				if (each.member_Id) {
					toCartValues.memberSelectedIds.push(each.member_Id);
					toCartValues.totalSelectedNames.push(each.member_Name);
					toCartValues.memberTextWithValue.push(this.workflowTemplateService.getAsCartSelectedValue(each.member_Id, each.member_Name));
					toCartValues.memberEventList.push({ text: this.workflowTemplateService.getAsCartSelectedValue(each.member_Id, each.member_Name).text });
				}
				toCartValues.previousBusinessGroupId = each.group_Id;
			} else if (each.assign_Type == 2) { // Cc:
				if (each.role_Id) {
					ccCartValues.roleSelectedIds.push(each.role_Id);
					ccCartValues.totalSelectedNames.push(each.role_Description);
					ccCartValues.roleTextWithValue.push(this.workflowTemplateService.getAsCartSelectedValue(each.role_Id, each.role_Description));
					ccCartValues.roleEventsList.push({ text: this.workflowTemplateService.getAsCartSelectedValue(each.role_Id, each.role_Description).text });
				}
				if (each.member_Id) {
					ccCartValues.memberSelectedIds.push(each.member_Id);
					ccCartValues.totalSelectedNames.push(each.member_Name);
					ccCartValues.memberTextWithValue.push(this.workflowTemplateService.getAsCartSelectedValue(each.member_Id, each.member_Name));
					ccCartValues.memberEventList.push({ text: this.workflowTemplateService.getAsCartSelectedValue(each.member_Id, each.member_Name).text });
				}
				ccCartValues.previousBusinessGroupId = each.group_Id;
			}
		});
		// pass values to mat expansion componet
		this.bodyInputComponent.setFormValues({ inputData: grpdWorkflowStatus[this.selectedTaskId][0], toCartValues, ccCartValues, actionKendoArr: grpdActions[this.selectedTaskId], isFromWfTemplateList: isFromWfTemplateList, WorkflowActionCategory: this.workFlowTemplateApiResponse.workflowActionCategory });
	}
}
